define('views/transactions/transactions',[
	'views/_base/baseview',
	'text!views/transactions/transactions.html',
	'views/transactions/transaction',
	'models/accounts/accounttransaction_collection',
	'models/accounts/accounttransactiondata',
	'models/accounts/accounttransaction',
	'models/accounts/accounts',
	'views/shared/modal/modal_modern',
	'views/transactions/fee_summary',
	'css!vendors/jquery/datetimepicker/2.2.9/jquery.datetimepicker'
], function(BaseView, Template, AccountTransactionView, AccountTransactionCollection, AccountTransactionDataModel, AccountTransactionModel, AccountsModel, ModalComponent, FeeSummaryComponent) {
	'use strict';

	return BaseView.extend({
		className: 'transactions-container',
		tagName: 'div',
		isRender: true,
		template: _.template(Template),
		events: {
			'click .js-sort-link' 		: 'sortTransaction',
			'click .transactions-custom': 'toggleCustomOptions',
			'click .select-wrapper' 	: 'showSelectOptions',
			'click .select-option' 		: 'handleOptionValue',
			'click #back-to-previous' 	: 'backToPrevious',
			'click .js-custom-range-picker-apply'     : 'getCustomDateTrasactions',
			'click .js-transaction-fee-summary-button': 'showFeeSummary'
		},

		initialize: function(options){
			
			/*
				TODO Transaction section is a temp mish mash of old and new code, so it can use some cleaning up whenever possible.
			*/
			
			options = options || {};
			this.account_id = options.account_id;
			this.elementName = options.elementName;
			/**
			 * period types
				1 - last statement
				2 - by date range
			 */
			this.period_type = 2;
			this.last_days_count = 7;
			this.PN = options.PN === undefined || options.PN === null ? 1 : options.PN;
			this.init_run = true;
			this.show_button = true;
			this.beyond_31_days = false;
			
			this.accounts_model = new AccountsModel();
			this.collection = new AccountTransactionCollection();
			this.model = new AccountTransactionDataModel();
						
            this.site_version = pf.getContent('version.id');

            this.wellness = pf.getFeature(enums.features.wellness);
			
			BaseView.prototype.initialize(this);
		},

		render: function(){
			var that = this;

            if(pf.IsConsumerFinancial){

                if(pf.routeHistory.length >= 2){
                    var route_name = pf.routeHistory[pf.routeHistory.length - 2].name;
                    if (route_name == "showSaving" || route_name == "showWallet") {
                        this.show_button = true;
                    }
                }
                
                this.$el.html(this.template( {show_button: this.show_button }));

                this.transaction_container = this.$(".js-transaction-list");
                this.picker_container = this.$(".custom-range-picker-container");
                this.picker_from = this.$(".picker-from");
                this.picker_to = this.$(".picker-to");
                this.from_input = this.$("#date-picker-from");
                this.to_input = this.$("#date-picker-to");
                this.from_label = this.$(".js-date-from");
                this.to_label = this.$(".js-date-to");
                this.default_text = "Choose Date";
				this.account_number_parent = this.$(".account-number-container");
				this.account_number_el = this.$(".js-transactions-acc-num");
				this.cnum_el = this.$(".js-transactions-cnum");
				this.transaction_range = this.$(".transaction-range");
				this.date_from_el = this.$(".js-transaction-date-from");
				this.date_to_el = this.$(".js-transaction-date-to");
				this.account_info_inner_el = this.$(".account-info-inner");
				this.balances_container = this.$(".account-balances");
				this.balances_starting_el = this.$(".js-transaction-sb");
				this.balances_ending_el = this.$(".js-transaction-eb");
				
				
                
                this.picker_from.datetimepicker({
                    timepicker: false,
                    closeOnDateSelect: true,
                    format: 'm/d/Y',
                    onShow: function(ct){

                        this.setOptions({
                            maxDate   : that.to_input.val() != "" ? that.to_input.val() : false,
                            formatDate: 'm/d/Y'
                        });

                    },
                    onClose: function(date, element){             
                        
                        var formatted_date = $(element).val(),
                        	one_day_out = moment(formatted_date).add(1, 'days').format('L'),
                        	thirty_one_days_out = moment(formatted_date).add(31, 'days').format('L'),
                        	to_date = that.picker_to.val();
                        
                        if(formatted_date){

                        	that.from_input.val(formatted_date);
                        
	                        that.from_label.text(formatted_date);

	                        if(that.picker_from.hasClass('error')){
	                        	that.picker_from.removeClass('error');
	                        }

	                        that.picker_to.datetimepicker({
	                        	onShow: function(date){

			                        this.setOptions({
			                            minDate   : one_day_out,
			                            maxDate   : thirty_one_days_out,
			                            formatDate: 'm/d/Y'
			                        });

			                    }
	                        });

	                        if(to_date){

	                        	that.checkDateRange();

	                        }

                        }

                    }
                });

                this.picker_to.datetimepicker({
                    timepicker: false,
                    closeOnDateSelect: true,
                    format: 'm/d/Y',
                    onShow: function(date){

                        this.setOptions({
                            minDate   : that.from_input.val() != "" ? that.from_input.val() : false,
                            formatDate: 'm/d/Y'
                        });

                    },
                    onClose: function(date, element){
                        
                        var formatted_date = $(element).val();

                        if(formatted_date){

                        	that.to_input.val(formatted_date);
                        
                        	that.to_label.text(formatted_date);

	                        that.checkDateRange();

                        }
                        
                    }
                });
				
				if (!_.isUndefined(pf.accounts)) {
					// show account `static` account info
					that.showAccountInfo();
				} 

            } else {
                goToFinancialRegistration('transactions');
            }
			
			return this;
		},

		loadData: function(){
			
			var that = this;
						
			if(this.wellness){
								
				if(!pf.wellness_account){
					
                    pf.controller.loadWellnessAccount(function(){

                        that.loadTransactions();

                    });

				} else {
					that.loadTransactions();
				}
				
			} else {
								
				if(pf.accounts && pf.accounts.spending_account){
					that.loadTransactions();
				} else {
					
					pf.controller.loadAccounts(function(){
						that.loadTransactions();
					});
					
				}

			}

		},

		checkDateRange: function(){
			var from_date = this.picker_from.val(),
				to_date = this.picker_to.val(),
				now = moment(from_date),
				end = moment(to_date),
				duration = moment.duration(now.diff(end)),
				days = Math.abs(duration.asDays());
			
			// If to date is further out than 31 days, show error message
			if(days > 31){
				this.beyond_31_days = true;

				this.picker_from.addClass('error');
				this.picker_to.addClass('error');

				this.$('.js-custom-range-picker-error').show();

			} else {
				
				this.beyond_31_days = false;

				this.picker_from.removeClass('error');
				this.picker_to.removeClass('error');

				this.$('.js-custom-range-picker-error').hide();

			}

		},

		sortTransaction: function(e){
			
			var target = $(e.currentTarget),
				all_targets = this.$(".js-sort-link"),
				link_text = target.text().trim(),
				that = this;
			
			that.$(".select-wrapper-option-title.default").addClass("hidden");
			that.$(".js-selected").text(link_text);

			all_targets.removeClass("selected");
			target.addClass("selected");
						
			
			var attrs = target.data("period-type").split(",");
			that.period_type = Number(attrs[0]);
			that.last_days_count = (attrs[1].trim() == "custom") ? "custom" : Number(attrs[1]);

			that.picker_container.removeClass("active");
			// that.from_input.val("");
			// that.to_input.val("");
			that.to_label.text(that.default_text);
			that.from_label.text(that.default_text);
			
			//if not custom submit right away
			if (that.last_days_count !== "custom") {
				that.loadTransactions();
			}
			
		},

		toggleCustomOptions: function(e){
			this.picker_container.addClass("active");
			this.transaction_range.addClass("hidden");
		},

		showSelectOptions: function(e){
			var selectEl = $(e.target).find("ul"),
				allSelects = this.$(".select-wrapper-options-list"),
				wrapper = selectEl.parent();
			
			// remove any open select boxes
			allSelects.removeClass("showing");
			
			if (!wrapper.hasClass("disabled")) {
				selectEl.toggleClass("showing");
			} 
			
		},

		handleOptionValue: function(e){
			var target = $(e.currentTarget),
				that = this,
				default_label = that.$(".select-wrapper-option-title.default"),
				selected_text = that.$(".js-selected"),
				itemValue = target.find("a").text();

			var attrs = target.data("period-type").split(",");
			that.period_type = Number(attrs[0]);
			that.last_days_count = (attrs[1].trim() == "custom") ? "custom" : Number(attrs[1]);
			
			that.$(".navbar span > a").each(function(i, el){
				
				$(el).parent().removeClass("selected");
				
				if($(el).text() === itemValue){
					$(el).parent().addClass("selected");
				}
			})
			
			if(!target.hasClass("transactions-custom")){
				that.picker_container.removeClass("active")
			}
			
			// that.from_input.val("");
			// that.to_input.val("");
			that.to_label.text(that.default_text);
			that.from_label.text(that.default_text);
			
			default_label.addClass("hidden");
			selected_text.text(itemValue);

			//if not custom submit right away
			if(that.last_days_count !== "custom"){
				that.loadTransactions();
			}
		},

		backToPrevious: function(e){
			e.preventDefault();
			history.go(-1);
		},

		loadingList: function(){
			// reconfigured from v1
			this.transaction_container.html('<li class="list-loading"><div class="spinner hasPadding"></div></li>');
		},

		getAccountId: function(){

			if(this.account_id){
				var account_id = this.account_id;
			} else if(this.wellness){
				var account_id = pf.wellness_account.account_id;
			} else {
				var account_id = pf.accounts.spending_account.account_id;
			}

			return account_id;

		},

		getCustomDateTrasactions: function(){

			var from_date = this.from_input.val(),
				to_date = this.to_input.val();

			this.period_type = 2;
			this.last_days_count = 'custom';

			if(this.beyond_31_days){
				return false;
			}

			if(from_date && to_date){

				this.picker_from.removeClass('error');
				this.picker_to.removeClass('error');
				this.loadTransactions();

			} else {

				if(!from_date){
					this.picker_from.addClass('error');
				}

				if(!to_date){
					this.picker_to.addClass('error');
				}

			}
		},

		loadTransactions: function(){

			var that = this,
				date_string = '';

			that.hideDisplayRange();
			that.hideDisplayBalances();
			
			var account_id = this.getAccountId();

			if(!that.init_run){
				that.loadingList();
			}

			that.init_run = false;

			if(that.period_type !== 1){

				if(that.last_days_count == "custom"){
					//build search by specific date string
					var startdate = that.from_input.val();
					var enddate = that.to_input.val();

					date_string = "&startdate=" + startdate + "&enddate=" + enddate;

				} else {
					//build search by pre-selected date
					var ed = new Date();
					var sd = new Date();

					sd.setDate(sd.getDate() - that.last_days_count);
					var startdate = (sd.getMonth() + 1) + '/' + sd.getDate() + '/' + sd.getFullYear();
					var enddate = (ed.getMonth() + 1) + '/' + ed.getDate() + '/' + ed.getFullYear();

					date_string = "&startdate=" + startdate + "&enddate=" + enddate;
				}
			}


			this.model.fetch({
				url: pf.consumerURL + "/Accounts/TX/" + account_id + "?pn=" + that.PN + date_string + "&periodType=" + that.period_type
			}).done(function(response){

				that.collection = that.model.attributes.transaction_list;
				that.transaction_container.empty();
				that.addAll();

				that.showAccountInfo();

				if(that.last_days_count === "custom"){
					// two vals
					var dates = [];
					dates.push(that.from_input.val(),  that.to_input.val())
					that.displayRange(dates)
				} else {
					// one val
					that.displayRange(that.model)
				}

				if(that.period_type == 1){
					that.displayBalances(that.model);
				}

				if(that.period_type == 1){
					that.displayBalances(that.model);
				}

			}).fail(function(err) {
				that.transaction_container.html('<li class="error"><span>An error has occurred. Please try again later.</span></li>');
			});



		},
		
		showAccountInfo: function(){
			
            if(this.wellness){

                var account = pf.wellness_account,
                    proxy_number = account.proxy_number,
                    account_card_number = account.card_number;

            } else {

                var account = pf.accounts.spending_account,
                    proxy_number = (account) ? account.proxy_number : '',
                    account_card_number = (account) ? account.account_name.slice(account.account_name.indexOf('Account')+8) : '';

            }
			
			this.account_number_el.text(proxy_number);
			this.cnum_el.text(account_card_number);
			
			this.account_info_inner_el.removeClass("hidden");
			
		},
		
		displayRange: function(dates){

			var from_date = (dates && Array.isArray(dates)) ? dates[0] : dates.attributes.StartDate,
				to_date = (dates && Array.isArray(dates)) ? dates[1] : dates.attributes.EndDate;
						
			this.date_from_el.text(moment(from_date).format('MMMM D, YYYY'));
			this.from_label.text(moment(from_date).format('L'));

			this.date_to_el.text(moment(to_date).format('MMMM D, YYYY'));
			this.to_label.text(moment(to_date).format('L'));		

			this.transaction_range.removeClass("hidden");
		},
		
		hideDisplayRange: function(){
			this.transaction_range.addClass("hidden");
		},
		
		displayBalances: function(model){
			
			this.balances_starting_el.text(formatCurrency(model.attributes.StartingBalance));
			this.balances_ending_el.text(formatCurrency(model.attributes.EndingBalance));
			
			this.balances_container.removeClass("hidden");
		},

		hideDisplayBalances: function(){
			this.balances_container.addClass("hidden");
		},

		addAll: function(){
			
			var that = this;

			if(that.collection.length > 0){
				this.collection.forEach(that.addOne, that);
			} else {
				that.transaction_container.html('<li class="error">No transactions within this date range</li>');
			}
			
		},

		addOne: function(account_transaction) {
			var transaction = new AccountTransactionModel(account_transaction)
			var transaction_view = new AccountTransactionView({ model: transaction });
			this.transaction_container.append(transaction_view.el);
		},

		showFeeSummary: function(){
			var account_id = this.getAccountId(),
				fee_summary = new FeeSummaryComponent({ account_id: account_id });

			this.fee_summary_modal = new ModalComponent({
                show        : true, // True, if we want the modal to show itself when it's ready
                content     : fee_summary.$el.html(),
                calling_view: this // Send in corresponding view to inherit events and custom properties
            });

		},

		close: function() {}
	});
});

